import { Text } from '@chakra-ui/react';
import { useRenderLayerManager } from '@r-services/render-layers';

import { useRenderTracking } from '@r-services/render-tracking';

export type RenderInformationProps = {
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RenderInformation = (props: RenderInformationProps): React.ReactElement => {
	const allCounts = useRenderTracking();

	return (
		<div style={{
			zIndex: 10,
			maxWidth: '400px',
			backgroundColor: 'rgba(255, 255, 255, 0.55)',
			border: '1px solid #ccc',
			borderRadius: '8px',
			padding: '15px',
			boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
		}}>
			<h3 style={{ margin: '0 0 15px 0', fontSize: '16px' }}>Render Info (legacy)</h3>
			<div style={{ fontSize: '12px' }}>
				{Object.keys(allCounts).map((key, i) => {
					return (
						<div key={`render-${i}`}><strong>render:{key}:</strong> {allCounts[key]}</div>
					);
				})}
			</div>
		</div>
	);
};
